import { captureException } from '@sentry/react';
import { ErrorBoundary, type FallbackProps } from 'react-error-boundary';

import { ErrorState, type ErrorStateVariant } from './ErrorState';
import { useTranslation } from 'contexts/translation-context';

interface ErrorStateBoundaryFallbackProps extends FallbackProps {
  variant: ErrorStateVariant;
}

const ErrorStateBoundaryFallback: React.FC<ErrorStateBoundaryFallbackProps> = ({
  error,
  resetErrorBoundary,
  variant,
}) => {
  const { i18n } = useTranslation();

  return (
    <ErrorState error={error} onRetry={resetErrorBoundary} retryLabel={i18n('errors.reloadPage')} variant={variant} />
  );
};

export const ErrorStateBoundary: React.FC<{
  children: React.ReactNode;
  variant?: ErrorStateVariant;
}> = ({ children, variant = 'section' }) => {
  return (
    <ErrorBoundary
      fallbackRender={(fallbackProps) => <ErrorStateBoundaryFallback {...fallbackProps} variant={variant} />}
      onError={(err) => {
        captureException(err);
      }}
      onReset={() => {
        // eslint-disable-next-line no-restricted-globals
        window.location.reload();
      }}
    >
      {children}
    </ErrorBoundary>
  );
};
